import React, { useState, useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import UpdateWhiteLabelModal from './updateRequestModal'
import cookie from 'react-cookies'
import axios from 'axios'
import { WEB_BASE_URL } from '../../../unified/webbase'
export default function ViewWhiteLabelRequestInfo() {
    const token = cookie.load("token")
  const [requestInfo, setRequestInfo] = useState({
    appName: '',
    appColour: '',
    supportEmail: '',
    supportPhoneNumber: '',
    businessName: '',
    emailAddress: '',
    faqUrl: '',
    imageUrl: '',
    status: '',
    dateCreated: '',
    subDomainUrl: null,
    reason: null
  });

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchRequestInfo();
  }, []);

  const fetchRequestInfo = async () => {
    try {
      axios
      .get(WEB_BASE_URL + "/onboarding/get-kyc-user", {
        headers: {
          authorization: token,
        },
      })
      .then((res) => {
        setRequestInfo(res.data.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error fetching request information');
      });
    } catch (error) {
      toast.error('Error fetching request information');
      console.error('Error:', error);
    }
  };

  const handleUpdate = (updatedData) => {
    setRequestInfo(prevState => ({
      ...prevState,
      ...updatedData
    }));
  };

  return (
    <main className="page-content">
        <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5 className="card-title">White Label Request Information</h5>
                                {/* <button 
                                    className="btn btn-primary"
                                    onClick={() => setShowModal(true)}
                                >
                                    Update Information
                                </button> */}
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    {requestInfo.imageUrl && (
                                        <div className="mb-4">
                                            <label className="form-label fw-bold">App Logo</label>
                                            <div>
                                                <img 
                                                    src={requestInfo.imageUrl} 
                                                    alt="App Logo" 
                                                    className="img-fluid"
                                                    style={{ maxWidth: '200px', maxHeight: '200px' }}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Business Name</label>
                                        <p className="form-control-static">{requestInfo.businessName}</p>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">App Name</label>
                                        <p className="form-control-static">{requestInfo.appName}</p>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">App Color</label>
                                        <div className="d-flex align-items-center">
                                            <div
                                                style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    backgroundColor: requestInfo.appColour,
                                                    border: '1px solid #dee2e6',
                                                    borderRadius: '4px',
                                                    marginRight: '10px'
                                                }}
                                            ></div>
                                            <span>{requestInfo.appColour}</span>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">FAQ URL</label>
                                        <p className="form-control-static">
                                            <a href={requestInfo.faqUrl} target="_blank" rel="noopener noreferrer">
                                                {requestInfo.faqUrl}
                                            </a>
                                        </p>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Support Email</label>
                                        <p className="form-control-static">
                                            <a href={`mailto:${requestInfo.supportEmail}`}>
                                                {requestInfo.supportEmail}
                                            </a>
                                        </p>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Support Phone</label>
                                        <p className="form-control-static">
                                            <a href={`tel:${requestInfo.supportPhoneNumber}`}>
                                                {requestInfo.supportPhoneNumber}
                                            </a>
                                        </p>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Status</label>
                                        <p className="form-control-static">{requestInfo.status}</p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Date Created</label>
                                        <p className="form-control-static">
                                            {new Date(requestInfo.dateCreated).toLocaleDateString()}
                                        </p>
                                    </div>

                                    {requestInfo.reason && (
                                        <div className="mb-3">
                                            <label className="form-label fw-bold">Reason</label>
                                            <p className="form-control-static">{requestInfo.reason}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <UpdateWhiteLabelModal
            show={showModal}
            onClose={() => setShowModal(false)}
            currentData={requestInfo}
            onUpdate={handleUpdate}
        />
    </main>     
  )
}
